/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_TitleInputs */



/**
* | output |
* | --- |
* | "AWP Marine Consultancy Ltd - Global Marine Inspection Services" |
*
* @param {Home_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_title = /** @type {((inputs?: Home_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("AWP Marine Consultancy Ltd - 全球船舶检查服务")
	return /** @type {LocalizedString} */ ("AWP Marine Consultancy Ltd - Global Marine Inspection Services")
});